import React from 'react'
import { CircularProgress, Box, Typography, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
const useStyles = makeStyles(() => ({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 9999,
    width: '35vw',
    height: '60vh',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'all',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  spinner: {
    color: '#78839D',
  },
  text: {
    marginTop: 16,
    fontSize: 18,
    fontFamily: 'Poppins',
    fontWeight: 500,
    color: '#78839D',
  },
}))

const Loader = ({ show = false, message = 'Carregando dados...' }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  if (!show) return null
  return (
    <Box className={classes.overlay}>
      <Box className={classes.content}>
        <CircularProgress className={classes.spinner} />
        <Typography className={classes.text}>{t('loader.carregando')}</Typography>
      </Box>
    </Box>
  )
}

export default Loader
